import { createStyles } from 'antd-style';

import {
  ThemeBorderRadius,
  ThemeColors,
  ThemeFont,
  ThemeSpaces,
  hexToRgbaWithAlpha,
} from '../../theme';

export const useSimpleDialogStyles = createStyles(({ token }) => ({
  simpleDialog: {
    '&.SimpleDialog--TransformCenter': {
      transformOrigin: 'center !important',
    },

    [`@media (max-width: ${token.screenXSMax}px)`]: {
      margin: 0,
      maxWidth: '100vw',
    },

    '.ant-modal-content': {
      minHeight: 220,
      border: `1px solid ${ThemeColors.COLOR_WHITE}`,
      backgroundColor: ThemeColors.COLOR_WHITE2,
      boxShadow: `0 0 35px ${hexToRgbaWithAlpha(ThemeColors.COLOR_GREY6, 0.35)}`,
      borderRadius: ThemeBorderRadius.BORDER_RADIUS_MD,

      [`@media (min-width: ${token.screenMDMin}px)`]: {
        width: 360,
      },
      [`@media (max-width: ${token.screenSMMax}px)`]: {
        width: 280,
      },
    },

    '.ant-modal-body': {
      padding: `${ThemeSpaces.SPACE_XL}px ${ThemeSpaces.SPACE_NORM}px`,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },

    'h1.ant-typography': {
      fontWeight: 300,
      lineHeight: 1.25,
      marginBottom: ThemeSpaces.SPACE_NORM_15,
      textAlign: 'center',

      '&.sm': {
        fontSize: 32,
      },
      '&.margin-md': {
        marginBottom: ThemeSpaces.SPACE_NORM_20,
      },
      '&.margin-lg': {
        marginBottom: ThemeSpaces.SPACE_NORM_30,
      },
    },

    'h2.ant-typography': {
      fontWeight: 300,
      lineHeight: 1.25,
      marginBottom: ThemeSpaces.SPACE_NORM,
      textAlign: 'center',
      marginTop: 0,
    },

    'h4.ant-typography': {
      fontWeight: 500,
      lineHeight: 1.25,
      marginTop: 0,
      marginBottom: ThemeSpaces.SPACE_NORM,

      '&.margin-lg': {
        marginBottom: ThemeSpaces.SPACE_NORM_30,
      },
      [`@media (max-width: ${token.screenSMMax}px)`]: {
        fontSize: token.fontSizeLG,
      },
    },

    'span.ant-typography': {
      fontSize: token.fontSizeLG,
      lineHeight: '19px',
    },

    form: {
      width: '100%',
      marginBottom: ThemeSpaces.SPACE_NORM_20,
    },

    '.InlineLink.cancel-button': {
      fontSize: ThemeFont.FONT_SIZE_LG_MINUS,
      fontWeight: 'bold',
      color: ThemeColors.COLOR_RED,
      lineHeight: 1,
      alignSelf: 'flex-end',

      '> *': {
        textDecoration: 'underline',
      },
    },

    '.InlineLink': {
      fontWeight: 500,
      color: ThemeColors.COLOR_BLUE2,

      '> *': {
        textDecoration: 'underline',
      },
    },

    '&.size-sm .ant-modal-content': {
      width: 280,
    },

    '&.SimpleDialog--ThemeDark': {
      '.ant-modal-content': {
        border: `1px solid ${ThemeColors.COLOR_GREY_DARK5}`,
        backgroundColor: ThemeColors.COLOR_GREY_DARK2,
        boxShadow: `0 0 80px ${ThemeColors.COLOR_BLACK0_7}`,
        borderRadius: token.borderRadius,
      },
      '.ant-modal-body': {
        '&, .ant-typography': {
          color: ThemeColors.COLOR_GREY7_4,
        },
      },
    },
  },
  simpleDialogIcon: {
    position: 'absolute',
    top: 0,
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '100%',

    '&::before': {
      zIndex: -1,
      content: '""',
      position: 'absolute',
      top: 2,
      bottom: 2,
      right: 2,
      left: 2,
      backgroundColor: ThemeColors.COLOR_WHITE,
      borderRadius: '100%',
    },

    '> *': {
      display: 'block',
      color: ThemeColors.COLOR_RED,
      fontSize: 60,

      '&.size-md': {
        fontSize: 40,
      },
      '&.size-sm': {
        fontSize: 36,
      },
    },
  },
  simpleDialogLabel: {
    fontSize: 18,
    marginBottom: ThemeSpaces.SPACE_MD,

    [`@media (max-width: ${token.screenSMMax}px)`]: {
      fontSize: ThemeFont.FONT_SIZE_LG_MINUS,
    },
    [`@media (min-width: ${token.screenMDMin}px)`]: {
      fontSize: token.fontSizeHeading4,
    },
  },
}));
